import { _mapping } from '../i247.Mapping.js';
import { _utilities } from '../utilities.js';
import { CalendarHelpers, _data, Enums } from './data.tyre.js';
import Common from '../i247.Common.js';

class BookingDetailsPanel {
    // -------------------------------------------------------------------------------
    //  Private members
    // -------------------------------------------------------------------------------
    constructor() {
        this.calendarMaxDate = 120;
        this.MaxCalendarLength = 21;
        this.LeadHours = 16;
        this.hoursUntilFirstSelectableTime = 50;
        this.selectedDate = null;
        this.selectedTime = null;
        this.selectedDate2 = null;
        this.selectedTime2 = null;
        this.selectedDate3 = null;
        this.selectedTime3 = null;
        this._firstAvailableDateTime = null;
        this.saturdayHours = [
            "09:00",
            "10:00",
            "11:00",
            "12:00"
        ];
        this.weekdayHours = [
            "09:00",
            "10:00",
            "11:00",
            "12:00",
            "13:00",
            "14:00",
            "15:00",
            "16:00"
        ];
    }

    BindControls = () => {
        let _this = this;

        let selectedOptionId = _data.bookingDetails.serviceRequired;

        $('#CalendarContainer').show();

        let kendoCalendar = $('#calendar').data('kendoCalendar');

        if (!SITE_CAN_SELECT_MULTIPLE_DATES && !kendoCalendar) {
            if (selectedOptionId === 'D') {
                _data.bookingDetails.bookingTime && $('#bookingTimeDiv').show();
                $('#bookingTimeSelectionMobile').hide();
            } else if (selectedOptionId === 'M') {
                $('#bookingTimeDiv').hide();
                $('#bookingTimeSelectionMobile').show();

                $('input[name="AmPmSlotSelection"]').on('change', (e) => {
                    _this.selectedTime = $(e.target).val();
                });
            }

            CalendarHelpers.getUnavailableBookingDates(_this.InitCalendars);
            let availableHours = null;

            // First time round initialize pickers with current date, otherwise use existing
            let currentDate = new Date();
            if (currentDate.getDay() === 6) { // 6 = Saturday
                availableHours = _this.saturdayHours;
            } else {
                availableHours = _this.weekdayHours;
            }

            let availableDateTimes = [];
            $.each(availableHours, function (_index, value) {
                let hour = moment(value, 'HH:mm').hour();
                let minute = moment(value, 'HH:mm').minutes();

                let date = moment(currentDate.setHours(hour, minute)).toDate();
                availableDateTimes.push(date);
            });

            if (_data.bookingDetails.serviceRequired === 'D') {
                $('#bookingTimeSlot').kendoTimePicker({
                    dates: availableDateTimes
                });
                let timePicker = $('#bookingTimeSlot').data('kendoTimePicker');
                if (timePicker) {
                    timePicker.value(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 9));
                }
            } else {
                _this.selectedTime = $('input[name="AmPmSlotSelection"]:checked').val();
            }
        } else if (SITE_CAN_SELECT_MULTIPLE_DATES) {
            _this.selectedDate = $('#tyreBookingDate1').val();
            _this.selectedDate2 = $('#tyreBookingDate2').val();
            _this.selectedDate3 = $('#tyreBookingDate3').val();

            if (selectedOptionId === 'D') {
                $('.mobileTimeSelection').hide();
                $('#tyreBookingTime1').show();
                $('#tyreBookingTime2').show();
                $('#tyreBookingTime3').show();

                $('#tyreBookingTime1').on('change', function (e) {
                    _this.selectedTime = $(e.target).val();
                });

                $('#tyreBookingTime2').on('change', function (e) {
                    _this.selectedTime2 = $(e.target).val();
                });

                $('#tyreBookingTime3').on('change', function (e) {
                    _this.selectedTime3 = $(e.target).val();
                });

            } else if (selectedOptionId === 'M') {
                $('.mobileTimeSelection').show();
                $('#tyreBookingTime1').hide();
                $('#tyreBookingTime2').hide();
                $('#tyreBookingTime3').hide();

                $('input[name="tyreBookingTime1Mobile"]').on('change', function (e) {
                    _this.selectedTime = $(e.target).val();
                });

                $('input[name="tyreBookingTime2Mobile"]').on('change', function (e) {
                    _this.selectedTime2 = $(e.target).val();
                });

                $('input[name="tyreBookingTime3Mobile"]').on('change', function (e) {
                    _this.selectedTime3 = $(e.target).val();
                });
            }
            CalendarHelpers.getUnavailableBookingDates(_this.InitCalendars);
        }
    };

    InitializeFullSizeCalendar = (unavailableDates) => {
        let _this = this;
        let today = new Date();

        $("#calendar").kendoCalendar({
            disableDates: function (date) {
                if (_utilities.IsInArray(date, unavailableDates)) {
                    return true;
                }
                return false;
            },
            min:today,
            value: today,
            max: new Date(today.getFullYear(), today.getMonth(), today.getDate() + _this.MaxCalendarLength),
            format: 'dd/MM/yyyy hh:mm tt',
            dates: unavailableDates,
            month: {
                // template for dates in month view
                content: `# var customDate = data.date; #` +
                    `# var firstAvailableDate = new Date(new Date(document.getElementById('firstAvailableDate').value).setHours(0,0,0,0)); #` +
                    `# if (IsInArray(customDate, data.dates)) { #` +
                    `<span class='datesNotAvailable'> #= data.value # </span>` + `# } else { #` +
                    `<span class='# if (customDate.getTime() === firstAvailableDate.getTime()) { #firstAvailableDate# } else { #availableDate# } #'> #= data.value #</span>` +
                    `# } #`,
                empty: '<span class="datesNotAvailable">#= data.value #</span>'
            },
            change: function () {
                _this.selectedDate = moment(this.value()).format("DD/MM/YYYY");

                //Date has changed, clear time information
                _this.selectedTime = "";
                $('#bookingDetailsSection').find('input[id="bookingTimeSlot"]').val("");
                _this.showHideValidationMessage($("div#appointmentTimeInvalidMessage"), _this.selectedTime);

                _this.showHideValidationMessage($("div#appointmentDateInvalidMessage"), this.value().toJSON());

                let firstAvailableDate = new Date(_this._firstAvailableDateTime.getFullYear(), _this._firstAvailableDateTime.getMonth(), _this._firstAvailableDateTime.getDate());
                let formatedDate = new Date(this.value().getFullYear(), this.value().getMonth(), this.value().getDate());

                let availableHours = null;
                if (moment(formatedDate).day() === 6) { // 6 = Saturday
                    availableHours = _this.saturdayHours;
                } else {
                    availableHours = _this.weekdayHours;
                }

                var filteredAvailableHours = availableHours;
                if (moment(formatedDate).isSame(firstAvailableDate)) {
                    filteredAvailableHours = availableHours.filter(function (value, _index, _arr) {
                        let hour = moment(value, 'HH:mm').hour();
                        let minute = moment(value, 'HH:mm').minutes();
                        let valueTime = moment(formatedDate.setHours(hour, minute));

                        let firstAvailableTimeFormat = moment(_this._firstAvailableDateTime);

                        return valueTime.isSameOrAfter(firstAvailableTimeFormat);
                    });
                }

                var availableDateTimes = [];
                $.each(filteredAvailableHours, function (_index, value) {
                    let hour = moment(value, 'HH:mm').hour();
                    let minute = moment(value, 'HH:mm').minutes();

                    let date = moment(formatedDate.setHours(hour, minute)).toDate();
                    availableDateTimes.push(date);
                });

                if (_data.bookingDetails.serviceRequired === 'D') {
                    $("#bookingTimeDiv").show('slow');
                    let timePicker = $('#bookingTimeSlot').data('kendoTimePicker');
                    timePicker.setOptions({
                        dates: availableDateTimes,
                        change: OnChange
                    });

                    timePicker.min(availableDateTimes[0]);
                    timePicker.max(availableDateTimes[availableDateTimes.length - 1]);
                    timePicker.value(null);
                }

                function OnChange(e){
                    _this.selectedTime = $('#bookingDetailsSection').find('input[id="bookingTimeSlot"]').val();
                    _this.showHideValidationMessage($("div#appointmentTimeInvalidMessage"), _this.selectedTime);
                }

                $("#bookingDateDiv #bookingDate").val(kendo.toString(this.value(), 'dd/MM/yyyy'));
                _utilities.ShowNextRow($('#driverBookingCalendar'), 1, 'bd-row');
            },
            footer: false
        });
    };

    InitCalendars = unavailableDatesArray => {
        let _this = this;
        CalendarHelpers.getFirstAvailableDateTime()
            .then(firstDate => {
                _this._firstAvailableDateTime = new Date(firstDate);
                $('#firstAvailableDate').val(_this._firstAvailableDateTime);
                _this.InitializeFullSizeCalendar(unavailableDatesArray);
                _this.InitialiseFlatpickrCalender(unavailableDatesArray);
            })
            .catch(error => console.log(error));
    };

    Init = (moveNext, moveBack, forward) => {
        let _this = this;
        $("#bookingTimeDiv").hide();
        _this.BindControls(_this.MaxCalendarLength);

        if (_utilities.DoNotShowCalendar()) {
            if (forward) {
                moveNext();
            } else {
                moveBack();
            }
        }
    };

    InitialiseFlatpickrCalender = (unavailableDates) => {
        const today = new Date();
        const datesToExclude = [];
        const datesInView = [];

        const firstSelectableTime = this.firstSelectableDate();

        const fp = flatpickr(".date", {
            minDate: firstSelectableTime,
            maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + this.MaxCalendarLength),
            disable: [(date) => {

                var isUnavailableDate = this.dateInArray(unavailableDates, date);

                let result;
                const isFirstSelectableSameDate = date.toDateString() === firstSelectableTime.toDateString();

                switch (date.getDay()) {
                    case 0:
                        result = true;
                        break;
                    case 6:
                        result = isFirstSelectableSameDate ? firstSelectableTime.getHours() >= 12 : date < firstSelectableTime;
                        break;
                    default:
                        result = isFirstSelectableSameDate ? firstSelectableTime.getHours() >= 16 : date < firstSelectableTime;
                        break;
                }

                if (isUnavailableDate)
                    result = true;

                if (!this.dateInArray(datesInView, date)) {
                    if (date > today && date.getMonth() === today.getMonth()) {
                        datesInView.push(date);
                    }
                }

                if (result) {
                    if (!this.dateInArray(datesToExclude, date)) {
                        if (date > today) {
                           datesToExclude.push(date);
                        }
                    }
                }

                return result;
            }],
            dateFormat: "d/m/Y",
            onChange: (selectedDates, dateStr, instance) => {
                this.dateChanged(instance.input.id);
            },
            onOpen: (selectedDates, dateStr, instance) => {
                let daysLeftInView = datesInView.some(dayOfMonth =>
                    !this.dateInArray(datesToExclude, dayOfMonth)
                );

                if (!daysLeftInView) {
                    instance.changeMonth(1);
                }
            }
        });
    }

    dateChanged = (controlId) => {
        var date = this.newDate(controlId);
        var timeId = controlId.replace('Date', 'Time');

        var bookingTimes = date.getDay() == 6
            ? Enums.timesSaturday
            : Enums.timesWeekday;

        const firstSelectableTime = this.firstSelectableDate();

        $('#' + timeId).prop("disabled", false);
        $('#' + timeId).empty();

        if (_data.bookingDetails.serviceRequired === 'D') {
            bookingTimes.forEach(item => {
                const [hour, minute] = item.value.split(/[: ]/);
                const itemHour = minute === "00PM" && hour !== "12" ? parseInt(hour) + 12 : (minute === "00AM" && hour === "12" ? 0 : parseInt(hour));

                if (hour == "Please") {
                    this.addTime(timeId, item);
                }
                else if (date.toDateString() === firstSelectableTime.toDateString()) {
                    if (itemHour > firstSelectableTime.getHours()) {
                        this.addTime(timeId, item);
                    }
                } else {
                    this.addTime(timeId, item);
                }
            });
        }
    }

    addTime = (controlId, item) => {
        $('#' + controlId).append($('<option>', {
            value: item.id,
            text: item.value
        }));
    }

    newDate = (id, hours = null) => {
        if (!hours) {
            hours = 9;
        }

        var dateParts = $('#' + id).val().split("/");

        var date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        date.setHours(hours, 0, 0, 0);
        return date;
    }

    firstSelectableDate = () => {
        return new Date(new Date().getTime() + this.hoursUntilFirstSelectableTime * 60 * 60 * 1000);
    }

    dateInArray = (array, value) => {
        return !!array.find(item => {
            return item.getTime() == value.getTime();
        });
    }

    // -------------------------------------------------------------------------------
    //  Public members
    // -------------------------------------------------------------------------------

    InitializePanel = (moveNext, moveBack, forward) => {
        if (!SITE_CAN_SELECT_MULTIPLE_DATES) {
            // set kendo calendar to start by Monday
            kendo.culture().calendar.firstDay = 1;
        }
        this.Init(moveNext, moveBack, forward);
    }

    SaveBookingDetails = () => {
        let _this = this;
        let $panel = $('#bookingDetailsSection');

        if (SITE_CAN_SELECT_MULTIPLE_DATES) {
            _this.selectedDate = $('#tyreBookingDate1').val();
            _this.selectedDate2 = $('#tyreBookingDate2').val();
            _this.selectedDate3 = $('#tyreBookingDate3').val();
            _data.bookingDetails.bookingDate = _this.selectedDate;
            _data.bookingDetails.bookingDate2 = _this.selectedDate2;
            _data.bookingDetails.bookingDate3 = _this.selectedDate3;

            if ($("input[name='ServiceRequired']:checked").val() === 'D') {
                _data.bookingDetails.bookingTime = $panel.find('select[id="tyreBookingTime1"] option:selected').text();
            } else {
                _data.bookingDetails.bookingTime = $panel.find('input[name="tyreBookingTime1Mobile"]:checked').val();
            }

            if ($("input[name='ServiceRequired']:checked").val() === 'D') {
                _data.bookingDetails.bookingTime2 = $panel.find('select[id="tyreBookingTime2"] option:selected').text();
            } else {
                _data.bookingDetails.bookingTime2 = $panel.find('input[name="tyreBookingTime2Mobile"]:checked').val();
            }

            if ($("input[name='ServiceRequired']:checked").val() === 'D') {
                _data.bookingDetails.bookingTime3 = $panel.find('select[id="tyreBookingTime3"] option:selected').text();
            } else {
                _data.bookingDetails.bookingTime3 = $panel.find('input[name="tyreBookingTime3Mobile"]:checked').val();
            }

        } else {
            _data.bookingDetails.bookingDate = _this.selectedDate;

            if ($("input[name='ServiceRequired']:checked").val() === 'D') {
                _data.bookingDetails.bookingTime = $panel.find('input[id="bookingTimeSlot"]').val();
            } else {
                _data.bookingDetails.bookingTime = $panel.find('input[name="AmPmSlotSelection"]:checked').val();
            }
        }
    };

    showHideValidationMessage = ($validationElement, valid) => {
        if (SITE_CAN_SELECT_MULTIPLE_DATES) {
            if (valid) {
                Common.RemoveValidationStyles($validationElement);
            }
        } else {
            if (valid) {
                $validationElement.hide();
            } else {
                $validationElement.show('slow');
                Common.RemoveValidationStyles($("input[id^=bookingTimeSlot]"));
            }
        }

    };

    GetValidator = () => {
        let _this = this;

        let validator;

        if (SITE_CAN_SELECT_MULTIPLE_DATES) {
            let selectedOptionId = _data.bookingDetails.serviceRequired;

            validator = $('#bookingDetailsSection').kendoValidator({
                rules: {
                    validateDateOption1: () => !!$('#tyreBookingDate1').val(),
                    validateDateOption2: () => !!$('#tyreBookingDate2').val(),
                    validateDateOption3: () => !!$('#tyreBookingDate3').val(),

                    validateTimeOption1: () => {
                        if (selectedOptionId === 'M') {
                            return !!$('input[name="tyreBookingTime1Mobile"]:checked').val();
                        } else {
                            const timeValue = $('#tyreBookingTime1').val();
                            return timeValue && timeValue !== "0" && timeValue !== "";
                        }
                    },
                    validateTimeOption2: () => {
                        if (selectedOptionId === 'M') {
                            return !!$('input[name="tyreBookingTime2Mobile"]:checked').val();
                        } else {
                            const timeValue = $('#tyreBookingTime2').val();
                            return timeValue && timeValue !== "0" && timeValue !== "";
                        }
                    },
                    validateTimeOption3: () => {
                        if (selectedOptionId === 'M') {
                            return !!$('input[name="tyreBookingTime3Mobile"]:checked').val();
                        } else {
                            const timeValue = $('#tyreBookingTime3').val();
                            return timeValue && timeValue !== "0" && timeValue !== "";
                        }
                    },

                    validateMaxTwoSameDates: () => {
                        const dates = [$('#tyreBookingDate1').val(), $('#tyreBookingDate2').val(), $('#tyreBookingDate3').val()].filter(date => !!date);

                        const dateFrequency = dates.reduce((acc, date) => {
                            acc[date] = (acc[date] || 0) + 1;
                            return acc;
                        }, {});

                        return !Object.values(dateFrequency).some(count => count > 2);
                    },

                    validateUniqueDateTimeCombinations: () => {
                        const combinations = [
                            { date: $('#tyreBookingDate1').val(), time: selectedOptionId === 'M' ? $('input[name="tyreBookingTime1Mobile"]:checked').val() : $('#tyreBookingTime1').val() },
                            { date: $('#tyreBookingDate2').val(), time: selectedOptionId === 'M' ? $('input[name="tyreBookingTime2Mobile"]:checked').val() : $('#tyreBookingTime2').val() },
                            { date: $('#tyreBookingDate3').val(), time: selectedOptionId === 'M' ? $('input[name="tyreBookingTime3Mobile"]:checked').val() : $('#tyreBookingTime3').val() },
                        ];

                        const uniqueCombinations = new Set(combinations.map(c => `${c.date} ${c.time}`));
                        return uniqueCombinations.size === combinations.length;
                    }
                },
                messages: {
                    validateDateOption1: "Please select a date for Option 1",
                    validateDateOption2: "Please select a date for Option 2",
                    validateDateOption3: "Please select a date for Option 3",
                    validateTimeOption1: "Please select a time for Option 1",
                    validateTimeOption2: "Please select a time for Option 2",
                    validateTimeOption3: "Please select a time for Option 3",
                    validateMaxTwoSameDates: "You can select a maximum of two of the same date across the 3 options.",
                    validateUniqueDateTimeCombinations: "Date and Times must be unique across all 3 options."
                }
            }).data('kendoValidator');

            validator.bind('validate', function () {
                const isValidTime1 = $('#tyreBookingDate1').val() && (
                    selectedOptionId === 'M'
                        ? $('input[name="tyreBookingTime1Mobile"]:checked').val()
                        : $('#tyreBookingTime1').val() && $('#tyreBookingTime1').val() !== "0" && $('#tyreBookingTime1').val() !== ""
                );
                const isValidTime2 = $('#tyreBookingDate2').val() && (
                    selectedOptionId === 'M'
                        ? $('input[name="tyreBookingTime2Mobile"]:checked').val()
                        : $('#tyreBookingTime2').val() && $('#tyreBookingTime2').val() !== "0" && $('#tyreBookingTime2').val() !== ""
                );
                const isValidTime3 = $('#tyreBookingDate3').val() && (
                    selectedOptionId === 'M'
                        ? $('input[name="tyreBookingTime3Mobile"]:checked').val()
                        : $('#tyreBookingTime3').val() && $('#tyreBookingTime3').val() !== "0" && $('#tyreBookingTime3').val() !== ""
                );

                const dates = [$('#tyreBookingDate1').val(), $('#tyreBookingDate2').val(), $('#tyreBookingDate3').val()].filter(date => !!date);
                const dateFrequency = dates.reduce((acc, date) => {
                    acc[date] = (acc[date] || 0) + 1;
                    return acc;
                }, {});

                const hasThreeSameDates = Object.values(dateFrequency).some(count => count > 2);

                const dateTimeCombinations = [
                    { date: $('#tyreBookingDate1').val(), time: selectedOptionId === 'M' ? $('input[name="tyreBookingTime1Mobile"]:checked').val() : $('#tyreBookingTime1').val() },
                    { date: $('#tyreBookingDate2').val(), time: selectedOptionId === 'M' ? $('input[name="tyreBookingTime2Mobile"]:checked').val() : $('#tyreBookingTime2').val() },
                    { date: $('#tyreBookingDate3').val(), time: selectedOptionId === 'M' ? $('input[name="tyreBookingTime3Mobile"]:checked').val() : $('#tyreBookingTime3').val() },
                ];

                const uniqueCombinations = new Set(dateTimeCombinations.map(c => `${c.date} ${c.time}`));
                const hasNoDuplicateDateTime = uniqueCombinations.size === dateTimeCombinations.length;

                const hasValidationError = !isValidTime1 || !isValidTime2 || !isValidTime3 || hasThreeSameDates || !hasNoDuplicateDateTime;

                _this.showHideValidationMessage($("#tyreBookingTime1"), !hasValidationError);
                _this.showHideValidationMessage($("#tyreBookingTime2"), !hasValidationError);
                _this.showHideValidationMessage($("#tyreBookingTime3"), !hasValidationError);
            });
        } else {
            validator = $('#bookingDetailsSection').kendoValidator({
                rules: {
                    validateCalendar: () => {
                        return _utilities.DoNotShowCalendar()
                            ? true
                            : _this.selectedDate ? true : false;
                    },
                    validateTime: () => {
                        return _utilities.DoNotShowCalendar()
                            ? true
                            : _this.selectedTime ? true : false;
                    }
                },
                messages: {
                    validateCalendar: "Please select an appointment date",
                    validateTime: "Please select an appointment time"
                }
            }).data('kendoValidator');

            validator.bind('validate', function () {
                _this.showHideValidationMessage($("div#appointmentDateInvalidMessage"), _this.selectedDate);

                if ($("input[id^=bookingTimeSlot]").is(":visible")) {
                    _this.showHideValidationMessage($("div#appointmentTimeInvalidMessage"), _this.selectedTime);
                }
            });
        }

        return validator;
    };
};

export let _bookingPanel = new BookingDetailsPanel();
